<template>
  <div class="referred">
    <v-card-text>
      <div style="margin-bottom: 50px">
        <div class="req-list">
          <div class="req-card">
            <CRow>
              <CCol col="4">
                <CSelect
                    outlined
                    label="نوع محصول"
                    :options="product_types"
                    single-line
                    item-text="ProductTypeTitle"
                    item-value="Id"
                    :value.sync="selected_product_types"
                />
              </CCol>
              <CCol col="4">
                <CSelect
                    outlined
                    label="دسته محصول"
                    :options="product_cats"
                    single-line
                    item-text="CategoryTitle"
                    item-value="Id"
                    :value.sync="selected_product_cats"
                />
              </CCol>
              <CCol col="4">
                <CSelect
                    outlined
                    label="گروه محصول"
                    :options="product_groups"
                    single-line
                    item-text="CategoryGroupTitle"
                    item-value="Id"
                    :value.sync="selected_product_groups"
                />
              </CCol>
              <CCol col="4">
<div>
  خصوصیات محصول
</div>
                <treeselect
                    :multiple="true"
                    :options="product_details"
                    :normalizer="normalizer_properties"
                    placeholder="خصوصیات محصول"
                    v-model="selected_product_details"
                />

              </CCol>
              <CCol col="4">
                <CSelect
                    outlined
                    label="برند محصول"
                    :options="product_brands"
                    item-text="SubGroupTitle"
                    item-value="Id"
                    :value.sync="selected_product_brands"
                />
              </CCol>
              <CCol col="12">
                <div style="border: 1px solid grey;border-radius: 3px;margin-bottom: 3px;padding: 5px" @click="dialog_model=true">مدل دستگاه : {{product_model_title}}</div>
                <CTextarea
                    outlined
                    placeholder="توضیحات"
                    v-model="description"/>
                <div>{{ product_name }}</div>
              </CCol>






            </CRow>

          </div>

        </div>
      </div>

    </v-card-text>
    <CButton color="primary"

           style="font-weight:bold;border-radius: 0px; height: 45px;margin-top: 10px"
           class="enter-btn footer_btn" v-on:click="insert_pre_product()">
      افزودن کالا
    </CButton>
    <CModal
      :show.sync="dialog_model"
      max-width="290"
      fullscreen
      hide-overlay
    >

      <CCard class="category-modal">
        <CCardHeader class="headline">
          انتخاب مدل
        </CCardHeader>
        <CCardBody>
          <CRow>
<CCol>
  <treeselect
      :multiple="false"
      :load-options="load_models"
      :normalizer="normalizer_models"
      :async="true"

      placeholder="مدل دستگاه"
      v-model="product_model_id"
  />

</CCol>

          </CRow>
          <br>
          <br>
          <br>
          مدل

          <label>{{product_model_title}}</label>

        </CCardBody>
        <v-card-actions class="">
          <v-spacer></v-spacer>

          <CButton
            class="cancle-btn"
            text
            @click="dialog_model = false"
          >
            ثبت
          </CButton>

        </v-card-actions>
      </CCard>
    </CModal>

  </div>

</template>
<script>
import Treeselect, {ASYNC_SEARCH} from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import axios from "axios";


import {bus} from '../../main'

const simulateAsyncOperation = fn => {
  setTimeout(fn, 200)
}
export default {
  props: [
    'passing_data'
  ],
  data() {
    return {
      dialog_model:false,
      description: '',
      product_types: [],
      product_cats: [],
      product_groups: [],
      product_brands: [],
      product_details: [],
      selected_product_types: 0,
      selected_product_cats: 0,
      selected_product_groups: 0,
      selected_product_brands: 0,
      selected_product_details: [],
      product_name: '',
      product_model_id: 0,
      product_model_title: "",
      normalizer_models (node) {
        return {
          id: node.Id,
          label: node.Title,
        }
      },
      normalizer_properties (node) {
        return {
          id: node.ItemId,
          label: node.ItemTitle,
        }

      },
      search_entries: [],

    }
  },
  computed: {},
  components: {Treeselect},
  watch: {
    product_model_id () {
      for (var i = 0; i < this.search_entries.length; i++) {
        if (this.search_entries[i].Id == this.product_model_id) {
          this.product_model_title = this.search_entries[i].Title
        }
      }
    },
    selected_product_types: function () {
      this.get_product_cats()
      this.generate_product_name()
    },
    selected_product_cats: function () {
      this.get_product_groups()
      this.generate_product_name()
    },
    selected_product_groups: function () {
      this.get_product_brands()
      this.get_product_details()
      this.generate_product_name()
    },
    selected_product_brands: function () {
      this.generate_product_name()
    },
    selected_product_details: function () {
      this.generate_product_name()
    },
    product_model_title: function () {
      this.generate_product_name()
    },
  },
  mounted() {
    this.get_product_type()
  },

  methods: {
    load_models ({ action, searchQuery, callback }) {
      this.product_model_title = searchQuery
      var self = this
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          let options

          var passing_data = JSON.parse(localStorage.getItem('request_data'))

          const send_data = {
            txt: searchQuery,
            sgid: this.selected_product_brands,
          }
          axios.post('https://panel.zoodkomak.com/ZkpWebService/GetProductModels', send_data, {})
            .then(response => {
              self.search_entries = response.data.results
              options = response.data.results
              callback(null, options)
              // this.$router.push({ path: "/post-login", params: {} });
            }).catch(e => {
            this.errors.push(e)
          })

          //
          // axios.post('/api/admin/product_search-tags', {
          //   search: searchQuery,
          //
          // }).then(function (response) {
          //   options = response.data;
          //   callback(null, options);
          //   // localStorage.setItem("api_token", response.data.access_token);
          //   // self.$router.push({ path: 'notes' });
          // })
          //   .catch(function (error) {
          //     self.message = 'Incorrect E-mail or password';
          //     self.showMessage = true;
          //     console.log(error);
          //   });

          //  const options = this.get_keywords(searchQuery);
          // const options = [1, 2, 3, 4, 5].map(i => ({
          //     id: `${searchQuery}-${i}`,
          //     name: `${searchQuery}-${i}`,
          // }))
        })
      }
    },

    generate_product_name() {
      var self = this
      try {
        const group_name = this.product_groups.filter(x => x.Id == this.selected_product_groups)[0].CategoryGroupTitle || '';
        const brand_name = this.product_brands.filter(x => x.Id == this.selected_product_brands)[0].SubGroupTitle || '';
        this.product_name =
          ' ' + group_name
        this.selected_product_details.forEach(function (val) {
          self.product_name += " " + self.product_details.filter(x => x.ItemId == val)[0].ItemTitle
        })
        this.product_name += " " + brand_name
        this.product_name += " " + this.product_model_title
      } catch (e) {
        console.log(e)
      }

    },
    get_product_type() {
      var self = this
      const send_data = {}
      // axios.post('/Register' , send_data,{
      axios.post('https://panel.zoodkomak.com/ZkpWebService/GetProductTypeList', send_data, {})
        .then(response => {
          if (response.data.error == 0) {

            self.product_types = []
            response.data.Types.forEach(function (val){
              self.product_types.push({label:val.ProductTypeTitle,ProductTypeTitle:val.ProductTypeTitle,value:val.Id,Id:val.Id})
            })
            self.selected_product_types = self.product_types[0].value
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    get_product_cats() {
      var self = this
      const send_data = {
        pTypeId: this.selected_product_types,
      }
      axios.post('https://panel.zoodkomak.com/ZkpWebService/GetReqTypeCategoryByTypeId', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            self.product_cats = []
            response.data.categories.forEach(function (val){
              self.product_cats.push({label:val.CategoryTitle,CategoryTitle:val.CategoryTitle,value:val.Id,Id:val.Id})
            })

            self.selected_product_cats = self.product_cats[0].value

          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    get_product_groups() {
      var self = this
      const send_data = {
        catId: this.selected_product_cats,

      }
      axios.post('https://panel.zoodkomak.com/ZkpWebService/GetReqCategoryGroupListRelByCatId', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            self.product_groups = []
            response.data.groups.forEach(function (val){
              self.product_groups.push({
                label:val.CategoryGroupTitle,
                CategoryGroupTitle:val.CategoryGroupTitle,
                value:val.Id,
                Id:val.Id})
            })
            self.selected_product_groups = self.product_groups[0].Id

          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    get_product_brands() {
      var self = this
      const send_data = {
        groupId: this.selected_product_groups,
      }
      // axios.post('/Register' , send_data,{
      axios.post('https://panel.zoodkomak.com/ZkpWebService/GetReqCategorySubGroupListRelByGrpId', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            self.product_brands = []
            response.data.subGroups.forEach(function (val){
              self.product_brands.push({label:val.SubGroupTitle,SubGroupTitle:val.SubGroupTitle,value:val.Id,Id:val.Id})
            })
            self.selected_product_brands = self.product_brands[0].Id

          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    get_product_details() {
      var self = this
      const send_data = {
        grpId: this.selected_product_groups
      }
      // axios.post('/Register' , send_data,{
      axios.post('https://panel.zoodkomak.com/ZkpWebService/GetProductGroupDetailsByKeyword', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            self.product_details = []
            response.data.Types.forEach(function (val){
              self.product_details.push({label:val.ItemTitle,value:val.ItemId,ItemId:val.ItemId,ItemTitle:val.ItemTitle})
            })


            self.selected_product_details = []
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
    insert_pre_product() {

      var self = this
      let details = []
      this.selected_product_details.forEach(function (val){
        const det = self.product_details.filter(x => x.ItemId == val)[0]
details.push(det);
      })
      // var user_id = JSON.parse(localStorage.getItem('profile')).UserId

      const json ={
        MobileNo:localStorage.getItem('mobile'),
        ProductTypeId:this.selected_product_types,
        CategoryId:this.selected_product_cats,
        GroupIdd:this.selected_product_groups,
        SubGroupId:this.selected_product_brands,
        ProductUnitId:1,
        ProductName:this.product_name,
        ModelId:this.product_model_id,
        ModelTitle:this.product_model_title,
        Description:this.description,
        GrpDetailValue:JSON.stringify(details)
      }

      // axios.post('/Register' , send_data,{
      axios.post('http://panel.zoodkomak.com/jetToken/AddProduct', json, {})
        .then(response => {
          bus.$emit('show_toast', [1500, response.data.msg])

          if (response.data.error == 0) {
            //zood_product_id
            // zood_vit_pro_id
            // product_name
            window.open('/dashboard/products/edit/'+response.data.pId+'/'+response.data.vtId+'/'+self.product_name)
          }
        }).catch(e => {
        this.errors.push(e)
      })
    },
  }
}
</script>
